import { theme } from 'styles';

/**
 * Maps an OTS type to its display color (aligned with OTS table indicators).
 *
 * @param otsType - OTS severity type (`BLUE`, `RED`, or other)
 * @returns Theme color hex for the given OTS type
 *
 * @example
 * getOtsTypeColor('RED'); // theme.color.red
 */
export const getOtsTypeColor = (otsType: string | undefined): string => {
  switch (otsType) {
    case 'BLUE':
      return theme.color.blue;
    case 'RED':
      return theme.color.red;
    default:
      return theme.color.grey75;
  }
};
